// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "polls-" + chunkId + ".js?v=" + {"vendors-node_modules_nextcloud_vue_dist_ncvuecomponents_js":"0fd1521376ad72e343a6","src_js_views_PollSelector_vue":"7bd4a67f8f0fdb554bf4"}[chunkId] + "";
};